import PackageListItem, { PackageListItemSkeleton } from "./PackageListItem";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Container from "@mui/material/Container";
const useStyles = makeStyles((theme) => ({
    packageList: {
        listStyle: "none",
        padding: 0,
        margin: 0,
        "& > li": {
            marginBottom: theme.spacing(2),
        },
    },
}));
const PackageList = ({ packageInfo }) => {
    const classes = useStyles();
    return (React.createElement("ul", { className: classes.packageList }, packageInfo.packages.map((pkg, index) => {
        return (React.createElement("li", { key: pkg.uuid },
            React.createElement(PackageListItem, { pkg: pkg })));
    })));
};
export const PackageListSkeleton = () => {
    const classes = useStyles();
    return (React.createElement(Container, null,
        React.createElement("ul", { className: classes.packageList },
            React.createElement("li", null,
                React.createElement(PackageListItemSkeleton, null)),
            React.createElement("li", null,
                React.createElement(PackageListItemSkeleton, null)))));
};
export default PackageList;
